export default __webpack_public_path__ + "static/media/enrich-file.f6b464d6.svg";